import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "confinedOffset3": "user-bag-page-by-username-2dc74d76-confinedOffset3-WXUgJq",
  "standardGridContainer": "user-bag-page-by-username-2dc74d76-standardGridContainer-WXUgJq",
  "wideOffset3": "user-bag-page-by-username-2dc74d76-wideOffset3-WXUgJq",
  "grid": "user-bag-page-by-username-2dc74d76-grid-WXUgJq",
  "wideOffset6": "user-bag-page-by-username-2dc74d76-wideOffset6-WXUgJq",
  "confinedOffset2": "user-bag-page-by-username-2dc74d76-confinedOffset2-WXUgJq",
  "defaultOffset1": "user-bag-page-by-username-2dc74d76-defaultOffset1-WXUgJq",
  "defaultOffset10": "user-bag-page-by-username-2dc74d76-defaultOffset10-WXUgJq",
  "tinyOffset9": "user-bag-page-by-username-2dc74d76-tinyOffset9-WXUgJq",
  "confinedOffset7": "user-bag-page-by-username-2dc74d76-confinedOffset7-WXUgJq",
  "wide5": "user-bag-page-by-username-2dc74d76-wide5-WXUgJq",
  "tiny10": "user-bag-page-by-username-2dc74d76-tiny10-WXUgJq",
  "wide11": "user-bag-page-by-username-2dc74d76-wide11-WXUgJq",
  "xwideOffset3": "user-bag-page-by-username-2dc74d76-xwideOffset3-WXUgJq",
  "default3": "user-bag-page-by-username-2dc74d76-default3-WXUgJq",
  "confined3": "user-bag-page-by-username-2dc74d76-confined3-WXUgJq",
  "confined11": "user-bag-page-by-username-2dc74d76-confined11-WXUgJq",
  "default11": "user-bag-page-by-username-2dc74d76-default11-WXUgJq",
  "xwide1": "user-bag-page-by-username-2dc74d76-xwide1-WXUgJq",
  "tiny11": "user-bag-page-by-username-2dc74d76-tiny11-WXUgJq",
  "tiny12": "user-bag-page-by-username-2dc74d76-tiny12-WXUgJq",
  "wide10": "user-bag-page-by-username-2dc74d76-wide10-WXUgJq",
  "confined5": "user-bag-page-by-username-2dc74d76-confined5-WXUgJq",
  "default10": "user-bag-page-by-username-2dc74d76-default10-WXUgJq",
  "default12": "user-bag-page-by-username-2dc74d76-default12-WXUgJq",
  "tiny4": "user-bag-page-by-username-2dc74d76-tiny4-WXUgJq",
  "wideOffset1": "user-bag-page-by-username-2dc74d76-wideOffset1-WXUgJq",
  "xwide2": "user-bag-page-by-username-2dc74d76-xwide2-WXUgJq",
  "defaultOffset4": "user-bag-page-by-username-2dc74d76-defaultOffset4-WXUgJq",
  "wide9": "user-bag-page-by-username-2dc74d76-wide9-WXUgJq",
  "xwideOffset10": "user-bag-page-by-username-2dc74d76-xwideOffset10-WXUgJq",
  "tiny1": "user-bag-page-by-username-2dc74d76-tiny1-WXUgJq",
  "tiny8": "user-bag-page-by-username-2dc74d76-tiny8-WXUgJq",
  "tinyOffset4": "user-bag-page-by-username-2dc74d76-tinyOffset4-WXUgJq",
  "defaultOffset3": "user-bag-page-by-username-2dc74d76-defaultOffset3-WXUgJq",
  "confinedOffset4": "user-bag-page-by-username-2dc74d76-confinedOffset4-WXUgJq",
  "wideOffset5": "user-bag-page-by-username-2dc74d76-wideOffset5-WXUgJq",
  "wideOffset11": "user-bag-page-by-username-2dc74d76-wideOffset11-WXUgJq",
  "wide0": "user-bag-page-by-username-2dc74d76-wide0-WXUgJq",
  "tinyOffset3": "user-bag-page-by-username-2dc74d76-tinyOffset3-WXUgJq",
  "xwide7": "user-bag-page-by-username-2dc74d76-xwide7-WXUgJq",
  "default1": "user-bag-page-by-username-2dc74d76-default1-WXUgJq",
  "confinedOffset8": "user-bag-page-by-username-2dc74d76-confinedOffset8-WXUgJq",
  "defaultOffset11": "user-bag-page-by-username-2dc74d76-defaultOffset11-WXUgJq",
  "col": "user-bag-page-by-username-2dc74d76-col-WXUgJq",
  "confined9": "user-bag-page-by-username-2dc74d76-confined9-WXUgJq",
  "xwide8": "user-bag-page-by-username-2dc74d76-xwide8-WXUgJq",
  "confinedOffset11": "user-bag-page-by-username-2dc74d76-confinedOffset11-WXUgJq",
  "tinyOffset1": "user-bag-page-by-username-2dc74d76-tinyOffset1-WXUgJq",
  "wide3": "user-bag-page-by-username-2dc74d76-wide3-WXUgJq",
  "tiny2": "user-bag-page-by-username-2dc74d76-tiny2-WXUgJq",
  "xwideOffset8": "user-bag-page-by-username-2dc74d76-xwideOffset8-WXUgJq",
  "tinyOffset2": "user-bag-page-by-username-2dc74d76-tinyOffset2-WXUgJq",
  "confinedOffset0": "user-bag-page-by-username-2dc74d76-confinedOffset0-WXUgJq",
  "default6": "user-bag-page-by-username-2dc74d76-default6-WXUgJq",
  "xwideOffset0": "user-bag-page-by-username-2dc74d76-xwideOffset0-WXUgJq",
  "tinyOffset7": "user-bag-page-by-username-2dc74d76-tinyOffset7-WXUgJq",
  "confined0": "user-bag-page-by-username-2dc74d76-confined0-WXUgJq",
  "confined7": "user-bag-page-by-username-2dc74d76-confined7-WXUgJq",
  "xwide9": "user-bag-page-by-username-2dc74d76-xwide9-WXUgJq",
  "defaultOffset9": "user-bag-page-by-username-2dc74d76-defaultOffset9-WXUgJq",
  "xwideOffset11": "user-bag-page-by-username-2dc74d76-xwideOffset11-WXUgJq",
  "default0": "user-bag-page-by-username-2dc74d76-default0-WXUgJq",
  "defaultOffset5": "user-bag-page-by-username-2dc74d76-defaultOffset5-WXUgJq",
  "defaultOffset7": "user-bag-page-by-username-2dc74d76-defaultOffset7-WXUgJq",
  "wideOffset4": "user-bag-page-by-username-2dc74d76-wideOffset4-WXUgJq",
  "default7": "user-bag-page-by-username-2dc74d76-default7-WXUgJq",
  "wideOffset7": "user-bag-page-by-username-2dc74d76-wideOffset7-WXUgJq",
  "confined8": "user-bag-page-by-username-2dc74d76-confined8-WXUgJq",
  "wide8": "user-bag-page-by-username-2dc74d76-wide8-WXUgJq",
  "wide1": "user-bag-page-by-username-2dc74d76-wide1-WXUgJq",
  "default8": "user-bag-page-by-username-2dc74d76-default8-WXUgJq",
  "tiny9": "user-bag-page-by-username-2dc74d76-tiny9-WXUgJq",
  "wide4": "user-bag-page-by-username-2dc74d76-wide4-WXUgJq",
  "default5": "user-bag-page-by-username-2dc74d76-default5-WXUgJq",
  "row": "user-bag-page-by-username-2dc74d76-row-WXUgJq",
  "default9": "user-bag-page-by-username-2dc74d76-default9-WXUgJq",
  "tinyOffset6": "user-bag-page-by-username-2dc74d76-tinyOffset6-WXUgJq",
  "wideOffset10": "user-bag-page-by-username-2dc74d76-wideOffset10-WXUgJq",
  "confined4": "user-bag-page-by-username-2dc74d76-confined4-WXUgJq",
  "wide6": "user-bag-page-by-username-2dc74d76-wide6-WXUgJq",
  "tiny5": "user-bag-page-by-username-2dc74d76-tiny5-WXUgJq",
  "tinyOffset5": "user-bag-page-by-username-2dc74d76-tinyOffset5-WXUgJq",
  "wideGridContainer": "user-bag-page-by-username-2dc74d76-wideGridContainer-WXUgJq",
  "xwide12": "user-bag-page-by-username-2dc74d76-xwide12-WXUgJq",
  "wide2": "user-bag-page-by-username-2dc74d76-wide2-WXUgJq",
  "tiny0": "user-bag-page-by-username-2dc74d76-tiny0-WXUgJq",
  "xwideOffset5": "user-bag-page-by-username-2dc74d76-xwideOffset5-WXUgJq",
  "tinyOffset10": "user-bag-page-by-username-2dc74d76-tinyOffset10-WXUgJq",
  "tinyOffset11": "user-bag-page-by-username-2dc74d76-tinyOffset11-WXUgJq",
  "confinedOffset5": "user-bag-page-by-username-2dc74d76-confinedOffset5-WXUgJq",
  "wideOffset8": "user-bag-page-by-username-2dc74d76-wideOffset8-WXUgJq",
  "wideOffset0": "user-bag-page-by-username-2dc74d76-wideOffset0-WXUgJq",
  "xwideOffset6": "user-bag-page-by-username-2dc74d76-xwideOffset6-WXUgJq",
  "tinyOffset8": "user-bag-page-by-username-2dc74d76-tinyOffset8-WXUgJq",
  "xwide3": "user-bag-page-by-username-2dc74d76-xwide3-WXUgJq",
  "defaultOffset8": "user-bag-page-by-username-2dc74d76-defaultOffset8-WXUgJq",
  "wide12": "user-bag-page-by-username-2dc74d76-wide12-WXUgJq",
  "wideOffset2": "user-bag-page-by-username-2dc74d76-wideOffset2-WXUgJq",
  "confined2": "user-bag-page-by-username-2dc74d76-confined2-WXUgJq",
  "xwide6": "user-bag-page-by-username-2dc74d76-xwide6-WXUgJq",
  "defaultOffset6": "user-bag-page-by-username-2dc74d76-defaultOffset6-WXUgJq",
  "gridContainer": "user-bag-page-by-username-2dc74d76-gridContainer-WXUgJq",
  "wideOffset9": "user-bag-page-by-username-2dc74d76-wideOffset9-WXUgJq",
  "xwide4": "user-bag-page-by-username-2dc74d76-xwide4-WXUgJq",
  "xwide10": "user-bag-page-by-username-2dc74d76-xwide10-WXUgJq",
  "confined12": "user-bag-page-by-username-2dc74d76-confined12-WXUgJq",
  "xwideOffset1": "user-bag-page-by-username-2dc74d76-xwideOffset1-WXUgJq",
  "tiny7": "user-bag-page-by-username-2dc74d76-tiny7-WXUgJq",
  "confinedOffset1": "user-bag-page-by-username-2dc74d76-confinedOffset1-WXUgJq",
  "xwideOffset7": "user-bag-page-by-username-2dc74d76-xwideOffset7-WXUgJq",
  "xwideOffset9": "user-bag-page-by-username-2dc74d76-xwideOffset9-WXUgJq",
  "confined1": "user-bag-page-by-username-2dc74d76-confined1-WXUgJq",
  "default4": "user-bag-page-by-username-2dc74d76-default4-WXUgJq",
  "confined10": "user-bag-page-by-username-2dc74d76-confined10-WXUgJq",
  "default2": "user-bag-page-by-username-2dc74d76-default2-WXUgJq",
  "tinyOffset0": "user-bag-page-by-username-2dc74d76-tinyOffset0-WXUgJq",
  "xwideOffset2": "user-bag-page-by-username-2dc74d76-xwideOffset2-WXUgJq",
  "wide7": "user-bag-page-by-username-2dc74d76-wide7-WXUgJq",
  "confinedOffset6": "user-bag-page-by-username-2dc74d76-confinedOffset6-WXUgJq",
  "tiny6": "user-bag-page-by-username-2dc74d76-tiny6-WXUgJq",
  "confined6": "user-bag-page-by-username-2dc74d76-confined6-WXUgJq",
  "xwide0": "user-bag-page-by-username-2dc74d76-xwide0-WXUgJq",
  "xwide5": "user-bag-page-by-username-2dc74d76-xwide5-WXUgJq",
  "xwide11": "user-bag-page-by-username-2dc74d76-xwide11-WXUgJq",
  "armstrongGridContainer": "user-bag-page-by-username-2dc74d76-armstrongGridContainer-WXUgJq",
  "defaultOffset2": "user-bag-page-by-username-2dc74d76-defaultOffset2-WXUgJq",
  "confinedOffset9": "user-bag-page-by-username-2dc74d76-confinedOffset9-WXUgJq",
  "xwideOffset4": "user-bag-page-by-username-2dc74d76-xwideOffset4-WXUgJq",
  "tiny3": "user-bag-page-by-username-2dc74d76-tiny3-WXUgJq",
  "confinedOffset10": "user-bag-page-by-username-2dc74d76-confinedOffset10-WXUgJq"
};